<template>
  <el-dialog class="editFormDialog" :title="$lang('编辑订单')" :modal-append-to-body="true" :visible.sync="dialogVisible" width="1000px" :show-close="false"
             :close-on-press-escape="false" :close-on-click-modal="false">
    <el-form :model="orderForm" :rules="rules" ref="editOrderForm" label-width="100px" label-position="top" class="demo-ruleForm">
      <p class="form-title">{{ $lang('寄件人信息') }}</p>
      <div class="form-box">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item :label="$lang('寄件人姓名')" prop="senderName">
              <el-input v-model="orderForm.senderName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('寄件人手机号')" prop="senderMobilePhone">
              <el-input v-model="orderForm.senderMobilePhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('寄件省份')" prop="senderProvinceName">
              <el-input v-model="orderForm.senderProvinceName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('寄件城市')" prop="senderCityName">
              <el-input v-model="orderForm.senderCityName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$lang('寄件地区')" prop="senderAreaName">
              <el-input v-model="orderForm.senderAreaName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('寄件街道')" prop="senderDetailedAddress">
              <el-input v-model="orderForm.senderDetailedAddress" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <p class="form-title">{{ $lang('收件人信息') }}</p>
      <div class="form-box">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$lang('收件人姓名')" prop="receiverName">
              <el-input v-model="orderForm.receiverName" :placeholder="$t('请输入')" :maxLength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('收件人手机号')" prop="receiverMobilePhone">
              <el-input v-model="orderForm.receiverMobilePhone" :placeholder="$t('请输入')" :maxLength="20" @input="orderForm.receiverMobilePhone = orderForm.receiverMobilePhone.replace(/[^0-9+]/g, '')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('收件省')" prop="receiverProvinceId">
              <el-select v-model="orderForm.receiverProvinceId" filterable :key="orderForm.receiverProvinceName" @change="dataProvinceChange($event)">
                <el-option
                  v-for="item in provinceArray"
                  :key="item.id"
                  :label="(item[labelLang] + '（' + item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('收件城市')" prop="receiverCityId">
              <el-select v-model="orderForm.receiverCityId" filterable :key="orderForm.receiverCityId" @change="dataCityChange($event)">
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="(item[labelLang] + '（' + item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$lang('收件地区')" prop="receiverAreaId">
              <el-select v-model="orderForm.receiverAreaId" filterable :key="orderForm.receiverAreaId" @change="dataAreaChange($event)">
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="(item[labelLang] + '（' + item.enName + '）')"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('收件街道')" prop="receiverDetailedAddress">
              <el-input v-model="orderForm.receiverDetailedAddress" :placeholder="$t('请输入')" :maxLength="500"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$lang('物品重量(kg)')" prop="packageTotalWeight">
              <el-input-number v-model="orderForm.packageTotalWeight" :precision="2" :min="0" :max="999.99"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeEdit">{{ $lang('取消') }}</el-button>
      <el-button type="primary" @click="saveEdit">{{ $lang('保存') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { RESPONSE_SUCCESS } from '@constants'
import * as Api from '@api/base/public'
import { mapState } from 'vuex'
import { RULES } from '@utils/rules'

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      orderForm: {
        senderName: '', // 寄件人姓名
        senderMobilePhone: '', // 寄件人手机号
        senderProvinceName: '', // 发件省
        senderCityName: '', // 寄件城市
        senderAreaName: '', // 寄件城市
        senderDetailedAddress: '', // 寄件街道
        receiverName: '', // 收件人姓名
        receiverMobilePhone: '', // 收件人手机号
        receiverProvinceName: '', // 收件省
        receiverProvinceId: '', // 收件省
        receiverCityName: '', // 收件城市
        receiverCityId: '', // 收件城市
        receiverAreaName: '', // 收件地区
        receiverAreaId: '', // 收件地区
        receiverDetailedAddress: '', // 收件街道
        packageTotalWeight: '', // 物品重量
      },
      rules: {
        receiverName: [RULES.required],
        receiverMobilePhone: [RULES.required],
        receiverDetailedAddress: [RULES.required],
        receiverProvinceId: [RULES.requiredSelect],
        receiverCityId: [RULES.requiredSelect],
        receiverAreaId: [RULES.requiredSelect],
        packageTotalWeight: [RULES.required],
      },
      provinceArray: [], // 省
      cityList: [], // 市
      areaList: [], // 区
    }
  },
  watch: {
    rowData: {
      deep: true,
      immediate: true,
      handler(v) {
        this.orderForm = JSON.parse(JSON.stringify(v))
      }
    }
  },
  computed: {
    ...mapState(['lang']),
    labelLang() {
      return this.lang === 'EN' ? 'enName' : 'nativeName'
    },
  },
  created() {
    this.getProList()
  },
  methods: {
    // 获取酋长国数据
    async getProList() {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data
      } else {
        this.$message.error(msg)
      }
    },
    dataProvinceChange(value) {
      const obj = this.provinceArray.find(item => item.id === value)
      this.orderForm.receiverProvinceName = obj.enName
      this.getCityList(value)
    },
    // 获取城市数据
    async getCityList(parentId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data
        this.areaList = []
        this.orderForm.receiverCityId = ''
        this.orderForm.receiverAreaId = ''
      } else {
        this.$message.error(msg)
      }
    },
    dataCityChange(value) {
      const obj = this.cityList.find(item => item.id === value)
      this.orderForm.receiverCityName = obj.enName
      this.getAreaList(value)
    },
    // 获取区域数据
    async getAreaList(parentId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.areaList = data
        this.orderForm.receiverAreaId = ''
      } else {
        this.$message.error(msg)
      }
    },
    dataAreaChange(value) {
      const obj = this.areaList.find(item => item.id === value)
      this.orderForm.receiverAreaName = obj.enName
    },
    shopifyAddr() {
      this.$emit('showShopAddr', { orderStatusCode: this.orderForm.orderStatusCode, customerOrderId: this.orderForm.customerOrderId })
    },
    saveEdit() {
      this.$refs['editOrderForm'].validate((valida) => {
        if (valida) {
          const temp = JSON.parse(JSON.stringify(this.orderForm))
          if (temp.errorList) {
            delete temp.errorList
          }
          this.$emit('save', temp)
          this.closeEdit()
        }
      })
    },
    closeEdit() {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>
<style lang="scss">
.editFormDialog {
  .form-title {
    font-size: 18px;
    font-weight: bold;
  }
  .form-box {
    background-color: #f8f7f8;
    border-radius: 16px;
    padding: 10px 16px;
    //.el-form-item {
    //  margin-bottom: 10px !important;
    //}
    .el-form-item__label {
      padding: 0!important;
    }
    .senderBtn {
      color: #E60000;
      //height: 92px;
      //line-height: 120px;
      margin-top: 45px;
      display: flex;
      justify-content: flex-end;
      margin-right: 50px;
      i:hover, span:hover {
        cursor: pointer;
      }
    }
  }
  .el-dialog__body {
    height: 400px;
    overflow: auto;
  }
  .el-dialog__footer {
    text-align: center !important;
  }
}
</style>
